export function extractHttpErrorMessage(err: unknown): string {
  if (err == null) return '';
  if (typeof err === 'string') return err;
  if (typeof err !== 'object') return '';

  const record = err as Record<string, unknown>;
  const inner = record['error'];

  const innerString = readTrimmedString(inner);
  if (innerString) return innerString;

  const fromProblemDetails = readProblemDetailsMessage(inner);
  if (fromProblemDetails) return fromProblemDetails;

  return readTrimmedString(record['message']) ?? '';
}

function readProblemDetailsMessage(inner: unknown): string | null {
  if (!inner || typeof inner !== 'object') return null;
  const problem = inner as Record<string, unknown>;

  const detail = readTrimmedString(problem['detail']);
  if (detail) return detail;

  const firstValidationError = readFirstValidationError(problem['errors']);
  if (firstValidationError) return firstValidationError;

  const title = readTrimmedString(problem['title']);
  if (title) return title;

  return readTrimmedString(problem['message']);
}

function readFirstValidationError(errors: unknown): string | null {
  if (!errors || typeof errors !== 'object') return null;
  for (const value of Object.values(errors as Record<string, unknown>)) {
    if (Array.isArray(value) && typeof value[0] === 'string' && value[0].trim()) {
      return value[0];
    }
  }
  return null;
}

function readTrimmedString(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value : null;
}
